import { connect } from 'react-redux';

import { changeLearnMoreModalVisibility } from '../actions';
import UpsellBanner from '../components/sidebar/UpsellBanner';
import {
  getLineItemsSubscribableQuantity,
  getNumOfSubscribableItemsReqToCheckout,
} from '../selectors';

const mapStateToProps = state => {
  return {
    subscribableQuantity: getLineItemsSubscribableQuantity(state),
    requiredSubscribableItems: getNumOfSubscribableItemsReqToCheckout(state),
    isMembershipOrder: state.currentOrder.membership_order,
    minimumSubscriptionItems: state.minimumSubscriptionItems,
    hasSubscriptionCommitment: state.currentOrder.has_subscription_commitment,
    canBecomeMember: state.canBecomeMember,
    shippingCost: state.shippingCost,
    subscribableVariantDiscountRate: state.subscribableVariantDiscountRate,
    subscribableVariantFreeFrequency: state.subscribableVariantFreeFrequency,
  };
};

const mapDispatchToProps = dispatch => ({
  openLearnMoreModal: () => {
    dispatch(changeLearnMoreModalVisibility(true));
  },
  closeLearnMoreModal: () => {
    dispatch(changeLearnMoreModalVisibility(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UpsellBanner);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/UpsellBanner.js